/** Factures page (VIS1 PageFrame header). */
export const INVOICE_COPY = Object.freeze({ title: 'Factures' });

export const INVOICE_FORM_COPY = Object.freeze({
  period: 'Période', choosePeriod: 'Choisir une période', custom: 'Dates personnalisées',
  startDate: 'Date de début', endDate: 'Date de fin',
  cancel: 'Annuler', sendMail: 'Envoyer par mail', other: 'Autres actions',
  preview: 'Prévisualiser', pdf: 'Télécharger en PDF', attestation: 'Télécharger l’attestation SAP',
  individualPeriod: 'La période est calculée individuellement par famille.',
  statsFailed: 'Impossible de charger le solde et les périodes de cette famille. Réessayez.',
  noLessons: 'Aucun cours sur cette période', noUnpaid: 'Aucun cours impayé', noLastLesson: 'Aucun cours enregistré',
  annualAttachment: (year) => `L’attestation SAP ${year} sera jointe automatiquement à l’envoi par mail.`,
});
export const INVOICE_FORM_PERIODS = Object.freeze([
  { value: 'unpaid', label: 'Cours impayés' }, { value: 'last-lesson', label: 'Dernier cours' },
  { value: 'last-1', label: 'Dernier mois' }, { value: 'last-3', label: '3 derniers mois' },
  { value: 'current-month', label: 'Mois en cours' }, { value: 'last-year', label: 'Année dernière' },
  { value: 'current-year', label: 'Année en cours' }, { value: 'custom', label: 'Dates personnalisées' },
]);

export const INVOICE_RECORD_PERIODS = Object.freeze([
  { key: 'last-lesson', label: 'Dernier cours' },
  { key: 'last-1', label: 'Dernier mois' },
  { key: 'last-year', label: 'Année dernière' },
]);

export const INVOICE_PERIOD_COPY = Object.freeze({
  title: 'Quelle période facturer ?',
  family: (name) => `Pour la famille ${name}`,
  unpaid: 'Cours impayés',
  cancel: 'Annuler',
  loadFailed: 'Impossible de charger les périodes de facturation. Réessayez.',
  noLesson: 'Aucun cours enregistré pour cette famille.',
});

/** Invoice generator notifications (useNotify). */
export const INVOICE_NOTIFY = Object.freeze({
  periodRequired:   'Veuillez sélectionner une période',
  familyRequired:   'Veuillez sélectionner une famille',
  previewNeedsFamily: "Veuillez sélectionner une famille pour prévisualiser, ou activez l'envoi par email pour toutes les familles",
  previewFailed:    'Erreur lors de la génération de la facture',
  generateFailed:   'Erreur lors de la génération',
  downloadFailed:   'Erreur lors du téléchargement',
  sendFailed:       "Erreur lors de l'envoi",
  noFamilySelected: 'Aucune famille sélectionnée',
  noInvoiceToSend:  'Aucune facture générée à envoyer',
  pdfSaved:         'Facture enregistrée et PDF généré avec succès',
  pdfFailed:        'Erreur lors de la génération du PDF : ',
});

/** Bulk send result: invoices already emailed are skipped, never sent twice. */
export const INVOICE_BULK_COPY = Object.freeze({
  alreadySentOne:  "1 facture avait déjà été envoyée : elle n'a pas été renvoyée, la famille ne recevra aucun doublon. Son PDF reste téléchargeable en toute sécurité.",
  alreadySentMany: "{count} factures avaient déjà été envoyées : elles n'ont pas été renvoyées, aucune famille ne recevra de doublon. Leurs PDF restent téléchargeables en toute sécurité.",
});

/** InvoicePreview page. */
export const INVOICE_PREVIEW_COPY = Object.freeze({
  back:          'Retour',
  title:         'Facture · {name}',
  period:        'Du {start} au {end}',
  hours:         'Heures',
  amount:        'Montant',
  paid:          'Payé',
  balanceOwed:   'Reste à payer',
  balanceCredit: 'Crédit',
  balanceSettled:'Soldé',
  students:      'Élèves : {names}',
  globalOwed:    'Toutes périodes : {amount} restant à payer.',
  globalCredit:  'Toutes périodes : {amount} payés en avance.',
  globalSettled: "Toutes périodes : tous les cours jusqu'à cette date sont payés.",
  unpaidOutside: 'Des cours impayés existent en dehors de cette période.',
  urssafPending: "Les demandes Avance Immédiate URSSAF non confirmées ne sont pas prises en compte.",
  colDate:       'Date',
  colLabel:      'Désignation',
  colDuration:   'Durée',
  colTotal:      'Total HT',
  colStatus:     'Statut',
  payments:      'Paiements ({count})',
  noPayments:    'Aucun paiement lié aux cours de cette période',
  parties:       'Émetteur et client',
  issuer:        'Micro-entreprise',
  client:        'Client',
  siret:         'SIRET : {value}',
  agreement:     'Agrément : {value}',
  close:         'Fermer',
  pay:           'Payer',
  download:      'Télécharger PDF',
  downloading:   'Génération…',
  email:         'Envoyer par email',
  status: { 'payé': 'Payé', 'partiellement payé': 'Partiel', 'impayé': 'Impayé' },
});
